import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useViewport } from '@/hooks';
import { SquareStackIcon } from '@/icons';
import { IconButton, Tooltip } from '@/ui_v3';
import { useQuizList } from '../../useQuizList';
import { useQuizControl } from '../QuizControlProvider';
export const QuizDuplicateButton = ({
  disabled
}: {
  disabled?: boolean;
}) => {
  const {
    t
  } = useTranslation(['common', 'build']);
  const {
    isMobile
  } = useViewport();
  const {
    handleCopy
  } = useQuizList();
  const {
    index
  } = useQuizControl();
  return <Tooltip.Provider disableHoverableContent={isMobile} data-sentry-element="unknown" data-sentry-component="QuizDuplicateButton" data-sentry-source-file="QuizDuplicateButton.tsx">
      <Tooltip.Root data-sentry-element="unknown" data-sentry-source-file="QuizDuplicateButton.tsx">
        <Tooltip.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="QuizDuplicateButton.tsx">
          <IconButton size="xs" variant="outlined" intent="neutral" className="hidden mobile-lg:flex" disabled={disabled} onMouseDown={e => {
          e.preventDefault();
          e.stopPropagation();
        }} onClick={() => {
          handleCopy(index);
          logger.track('copy_quizItem', {
            position: 'card_button'
          });
        }} data-sentry-element="IconButton" data-sentry-source-file="QuizDuplicateButton.tsx">
            <SquareStackIcon size="xs" fill={disabled ? ICON_COLOR.disabled : ICON_COLOR.default} data-sentry-element="SquareStackIcon" data-sentry-source-file="QuizDuplicateButton.tsx" />
          </IconButton>
        </Tooltip.Trigger>
        <Tooltip.Content data-sentry-element="unknown" data-sentry-source-file="QuizDuplicateButton.tsx">{t('global.duplicate.button')}</Tooltip.Content>
      </Tooltip.Root>
    </Tooltip.Provider>;
};